import styled from 'styled-components'

import { Font16 } from 'components/Typography'
import theme from 'theme_'

export const KebabMenuItemLi = styled.li`
  padding: ${theme.spacing.xs} ${theme.spacing.base};
  cursor: pointer;
  ${Font16};
  transition: all 0.2s ease;

  &:hover {
    color: ${theme.colors.horizonOrange};
  }
`
